export default __webpack_public_path__ + "static/media/check.35b7211d.svg";